var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "box view-nav-bar" }, [
        _c("div", { staticClass: "d-flex align-items-center w-100" }, [
          _c("div", { staticClass: "flex-grow-1" }, [
            _c("strong", [_vm._v("Per movie")]),
            _vm._v(" "),
            _c("span", { staticClass: "text-muted ml-2" }, [
              _vm._v(
                "— top " +
                  _vm._s(_vm.bucket.top || 10) +
                  " movies per cinema year, all sessions vs. Brightfish preshow"
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "form-inline",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.goToMovie.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "label",
                { staticClass: "text-muted mr-2", attrs: { for: "movix-id" } },
                [_vm._v("Movix id")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.movixId,
                    expression: "movixId",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control form-control-sm shx-th-100",
                attrs: {
                  id: "movix-id",
                  type: "text",
                  pattern: "\\d+",
                  placeholder: "12345",
                },
                domProps: { value: _vm.movixId },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.movixId = $event.target.value.trim()
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-outline-secondary ml-2",
                  attrs: {
                    type: "submit",
                    disabled: !/^\d+$/.test(_vm.movixId),
                  },
                },
                [_vm._v("Open")]
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content text-center text-muted py-4" },
              [_vm._v("Loading…")]
            ),
          ])
        : !_vm.rows.length
        ? _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "box-content text-center text-muted py-4" },
              [_vm._v("No admissions data found.")]
            ),
          ])
        : [
            _vm._l(_vm.rows, function (year) {
              return _c("div", { key: year.year, staticClass: "box" }, [
                _c("div", { staticClass: "box-content" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center" },
                    [
                      _c("heading", {
                        staticClass: "flex-grow-1",
                        attrs: {
                          lower:
                            _vm.formatInt(year.admissions) +
                            " admissions, " +
                            _vm.formatInt(year.admissions_preshow) +
                            " preshow (" +
                            (year.pct_preshow !== null ? year.pct_preshow : 0) +
                            "%), " +
                            year.movies +
                            " movies over " +
                            year.weeks +
                            " weeks in " +
                            year.cinemas +
                            " cinemas",
                          border: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "upper",
                              fn: function () {
                                return [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to:
                                          "/admissions/movie/year/" + year.year,
                                      },
                                    },
                                    [_vm._v("Cinema year " + _vm._s(year.year))]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-sm btn-outline-secondary ml-3",
                          attrs: { to: "/admissions/movie/year/" + year.year },
                        },
                        [
                          _vm._v(
                            "\n                        Top 100\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                    _vm._m(0, true),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(year.top, function (movie, index) {
                        return _c("tr", { key: movie.movix_id }, [
                          _c("td", { staticClass: "text-muted" }, [
                            _vm._v(_vm._s(index + 1)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: "/admissions/movie/" + movie.movix_id,
                                  },
                                },
                                [_vm._v(_vm._s(movie.movix_id))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: "/admissions/movie/" + movie.movix_id,
                                  },
                                },
                                [_vm._v(_vm._s(movie.title || "—"))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "router-link",
                                {
                                  class: { "text-muted": !movie.movie_tag },
                                  attrs: {
                                    to: {
                                      path:
                                        "/admissions/movie/year/" + year.year,
                                      query: { tag: movie.movie_tag || "none" },
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(movie.movie_tag || "no tag"))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(movie.weeks)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(_vm.formatInt(movie.admissions))),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(movie.pct !== null ? movie.pct + "%" : "—")
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(_vm.formatInt(movie.admissions_preshow))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(
                                movie.pct_preshow !== null
                                  ? movie.pct_preshow + "%"
                                  : "—"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  movie.real_weighted != null
                                    ? movie.real_weighted + "%"
                                    : "—"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            movie.real_weighted != null &&
                            movie.real_weighted <= 90
                              ? _c(
                                  "span",
                                  { staticClass: "badge badge-warning ml-1" },
                                  [_vm._v("⚠")]
                                )
                              : _vm._e(),
                          ]),
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", [
                        _c("td", { attrs: { colspan: "5" } }, [
                          _c("strong", [
                            _vm._v("Top " + _vm._s(year.top.length)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.formatInt(_vm.sum(year.top, "admissions"))
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.pct(
                                  _vm.sum(year.top, "admissions"),
                                  year.admissions
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.formatInt(
                                  _vm.sum(year.top, "admissions_preshow")
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.pct(
                                  _vm.sum(year.top, "admissions_preshow"),
                                  year.admissions_preshow
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td"),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            }),
            _vm._v(" "),
            _vm._m(1),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "shx-th-50" }, [_vm._v("#")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-80" }, [_vm._v("Movix")]),
        _vm._v(" "),
        _c("th", [_vm._v("Title")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-120" }, [_vm._v("Tag")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("# Weeks")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Admissions")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("% of year"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("Preshow (BF)"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("% of preshow"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("Real %")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "box-content" }, [
        _c("p", { staticClass: "text-muted small mb-0" }, [
          _vm._v(
            "\n                    A cinema year runs from week C01 to the last cinema week (Wednesday to Tuesday).\n                    "
          ),
          _c("strong", [_vm._v("Admissions")]),
          _vm._v(" = every "),
          _c("code", [_vm._v("admissions_week")]),
          _vm._v(
            " row of the movie, whatever the sales house;\n                    "
          ),
          _c("strong", [_vm._v("Preshow")]),
          _vm._v(" = rows with "),
          _c("code", [_vm._v("saleshouse = BF")]),
          _vm._v(
            ". The year totals include titles\n                    without a Movix id, so the shares are of everything reported that year.\n                    "
          ),
          _c("strong", [_vm._v("Real %")]),
          _vm._v(" is the admissions-weighted average of "),
          _c("code", [_vm._v("real")]),
          _vm._v(
            ": 97.5 = fully\n                    compiled from Cinedata, lower = partly estimated.\n                    Same data as JSON: "
          ),
          _c("code", [_vm._v("GET /api/v1/admissions/movie")]),
          _vm._v(".\n                "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }